module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAAAv0lEQVQ4jbVV0Q2FIAy89yZ4IziCoziKozjCG8ERHMEROoIb1JCUpJaC/YBLLlE5jgIHfpgZPfF1vCYABIBfSKJ9IlVouHMcu+1vzRZltTqDZa5Kt9QMf8xMIjobZpmnaEn6FoabGnUOGM5Kv1lDtzHAoohm+fJ8qE6H0/5YpuYCGzNtWt3I9OGSlyICSvgXZkyVqF1esCOgqmbElLtvypDYdA/2kKPX/XKwmYrg9fpKTKHNU28haWzA0fcXAOAGpphMn8z/D8wAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/el_msg_voice_setting.png
// module id = jIPQ
// module chunks = 59 60 62 63 64 65 66 67 68 69 70 71 72 73 74 75 76 77 78 79 80 81 82